module.exports = __webpack_public_path__ + "img/swipe (8).a4952f7c.jpg";